(() => {
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  function init() {
    document.querySelectorAll('[data-pin-board]').forEach(board=>{
      if(board.dataset.interactive)return;
      board.dataset.interactive='true';
      if(matchMedia('(pointer:fine)').matches) {
        board.addEventListener('pointermove',event=>{
          if(reduced.matches)return;
          const rect=board.getBoundingClientRect();
          board.style.setProperty('--tilt-x',`${((event.clientY-rect.top)/rect.height-.5)*-3}deg`);
          board.style.setProperty('--tilt-y',`${((event.clientX-rect.left)/rect.width-.5)*5}deg`);
        });
        board.addEventListener('pointerleave',()=>{board.style.removeProperty('--tilt-x');board.style.removeProperty('--tilt-y');});
      }
    });
  }
  document.addEventListener('click',event=>{
    const postcard=event.target.closest('[data-flip-postcard]');
    if(postcard){const flipped=postcard.getAttribute('aria-pressed')!=='true';postcard.setAttribute('aria-pressed',String(flipped));postcard.querySelector('.postcard-front')?.setAttribute('aria-hidden',String(flipped));postcard.querySelector('.postcard-back')?.setAttribute('aria-hidden',String(!flipped));}
    const character=event.target.closest('[data-variant-choice]');
    if(character){const select=character.closest('form').querySelector('[data-variant-select]');select.value=character.dataset.variantChoice;select.dispatchEvent(new Event('change',{bubbles:true}));}
    const heart=event.target.closest('[data-save-pin]');
    if(heart&&!reduced.matches)requestAnimationFrame(()=>{if(heart.getAttribute('aria-pressed')==='true'){heart.classList.remove('is-sparkling');requestAnimationFrame(()=>heart.classList.add('is-sparkling'));}});
  });
  document.addEventListener('shopify:section:load',init);
  init();
})();
